import { React , useEffect, useState, useRef } from "react";

import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StarIcon from '@mui/icons-material/Star';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

import store from "../../../../../../store";
import {CONTENT} from '../../../../../../Store/Actions';

function RiskQuestion({onPriorityUpdate, priorityChoices, questionIndex, toolTipCopy}){

    const [showToolTip, setShowToolTip] = useState(false)
    let initialToolTipShowTimeout = useRef(setTimeout(() => {
        
    }, 0))

    useEffect(() => {

        if(!store.getState().hasShownFavouriteToolTip){

            setShowToolTip(true) 
            initialToolTipShowTimeout.current = setTimeout(() => {
                                                    setShowToolTip(false) 
                                                }, 5000);
            store.dispatch({ type: CONTENT.FAVOURITE_TOOL_TIP_SHOWN, payload: true })

        }

    }, [])

    function onHover(){
        clearTimeout(initialToolTipShowTimeout.current);
        setShowToolTip(true);
    }

    function onRollOut(){
        setShowToolTip(false);
    }

    return (
        <>
            <Tooltip onMouseOut={onRollOut} onMouseOver={onHover} title={<span dangerouslySetInnerHTML={{__html:toolTipCopy}}/>} open={showToolTip}>
                <Checkbox 
                    icon={
                        
                        <StarBorderOutlinedIcon 
                            sx={
                                {
                                    height: '20px',
                                    width:'20px',
                                    fill:"#000000 !important"
                                }
                            }
                        />

                    } 
                    checkedIcon={
                        <StarIcon 
                            sx={
                                {
                                    height: '20px',
                                    width:'20px',
                                }
                            }
                        />
                    } 
                    name="isPriority"
                    checked={priorityChoices.indexOf(questionIndex) !== -1 ? true : false}
                    onChange={(e) =>{
                        //SOME CODE TO SEND EITHER TRUE OR FALSE
                        onPriorityUpdate(questionIndex, e.currentTarget.checked)
                    }}

                    sx={{
                        marginLeft: '-38px'
                    }}
                />
            </Tooltip>
        </>
    )
}
export default RiskQuestion